module.exports = __webpack_public_path__ + "img/img1.2d413cf3.jpg";